
import { defineComponent } from "vue";

export default defineComponent({
  name: "AdminBillingOverview",
  components: {},
});
